/** @type {import('vanilla-cookieconsent')} */

/** @type {initCookieConsent} */
import "vanilla-cookieconsent";

/** @type {CookieConsent} */
const cookieconsent = initCookieConsent();

cookieconsent.run({
  revision: 1,
  page_scripts: true,
  autorun: true,
  gui_options: {
    consent_modal: {
      consent_modal: {
        layout: 'box',
        position: 'bottom center',
        transition: 'slide',

      },
      settings_modal: {
        layout: 'box',
        position: '',
        transition: 'slide',
      },
    },
  },
  languages: {
    en: {
      consent_modal: {
        title: 'This website uses cookies',
        description: `On this website, we use cookies ("cookies") so that you as a visitor can have the best possible experience and so that we can collect statistics and marketing with the aim of improving our website.<br><br>Click on "Accept all" if you want to accept all cookies or "Manage cookies" to choose which cookies you wish to accept. <a href="${mcc.privacy_policy_url}">Read the privacy policy</a>`,
        primary_btn: {
          text: 'Accept all',
          role: 'accept_all'
        },
        secondary_btn: {
          text: 'Manage cookies',
          role: 'settings'
        },
      },
      settings_modal: {
        title: 'Manage cookies',
        save_settings_btn: 'Save',
        accept_all_btn: 'Save and accept all',
        cookie_table_headers: [
          { col1: 'Name' },
          { col2: 'Domain' },
          { col3: 'Storage time' },
          { col4: 'Description' }
        ],
        blocks: [
          {
            description: `${mcc.site_name} uses cookies ("cookies") on the website ${mcc.home} to improve your user experience, but not all cookies are necessary for the website to function.`
          },
          {
            title: 'Necessary',
            description: 'These are cookies that are absolutely necessary to use the website properly.',
            toggle: {
              value: 'necessary',
              enabled: true,
              readonly: true
            },
            cookie_table: [
              {
                col1: 'PHPSESSID',
                col2: 'www.mcc-hvac.com',
                col3: 'session',
                col4: 'This cookies is used to identify the current user session on the server.',
              },
              {
                col1: 'location',
                col2: 'www.mcc-hvac.com',
                col3: 'one week',
                col4: 'This cookies is used to remember the selected user location.',
              },
              {
                col1: 'cc_cookie',
                col2: '.mcc-hvac.com',
                col3: 'one year',
                col4: 'This cookie is used to keep track of user cookie settings.',
              },
            ]
          },
          {
            title: 'Statistics',
            description: 'These are cookies used for website statistics.',
            toggle: {
              value: 'analytics',
              enabled: false,
              readonly: false
            },
            cookie_table: [
              {
                col1: '_gat_gtag_UA_100326688_1',
                col2: '.mcc-hvac.com',
                col3: 'one minute',
                col4: 'Used by Google Analytics to limit the number of requests sent.',
              },
              {
                col1: '_gid',
                col2: '.mcc-hvac.com',
                col3: 'one day',
                col4: 'Used by Google Analytics to register a unique ID that is used to record data about how the website is used by its users.',
              },
              {
                col1: '_ga',
                col2: '.mcc-hvac.com',
                col3: 'one day',
                col4: 'Used by Google Analytics to save data on how many times the user has visited the website as well as the date on which the user visited the page for the first and last time.',
              },
            ]
          }
        ]
      }
    }
  }
});